import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../constants/colors'
import { EN_ACCEPT_LANGUAGE } from '../constants/acceptLanguageApi'
import { MerChantModel } from '../models/merChantModel'
import { useTranslation } from 'react-i18next'

interface Props {
    merchantData: MerChantModel[]
    value: string
    onSelectMerchant: (e: any) => void
    role?: string | undefined
}

const SelectedBranchComponentVoid = ({ merchantData, value, onSelectMerchant, role }: Props) => {
    const { t, i18n } = useTranslation('global')

    return (
        <FormControl fullWidth sx={{ maxWidth: 250 }} size="small">
            <InputLabel id="merchant-label-id" shrink={true}>{t("Branch")}</InputLabel>
            <Select
                labelId="merchant-label-id"
                id="merchant-id"
                value={value}
                label="Merchant"
                onChange={onSelectMerchant}
                sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
            >
                {role === 'SUPER_ADMIN' && (
                    <MenuItem value="All">{t("order_page.All")}</MenuItem>
                )}
                {
                    merchantData?.map((item: MerChantModel) => <MenuItem key={item?.id} value={item?.id}><span style={{ color: TEXT_TITLE_COLOR }}>{item?.company} : </span> {i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                }
            </Select>
        </FormControl>
    )
}

export default SelectedBranchComponentVoid